import { configureStore } from "@reduxjs/toolkit";
import classSlice from "../components/class/redux/classSlice";
import subjectSlice from "../components/subject/redux/subjectSlice";
import chapterSlice from "../components/chapter/redux/chapterSlice";
import questionBankReducer from "../components/questionBank/redux/questionBankSlice";
import lawCollegeQuizReducer from "../components/LawCollegeQuiz/redux/lawCollegeSlice";
import schoolQuizReducer from "../components/SchoolQuiz/redux/schoolQuizSlice";
import quizMgtReducer from "../Quiz-Mgt-admin/redux/slice";
import schlQuizMgtReducer from "../School-Quiz-Mgt-admin/redux/slice";
import categoryReducer from "../components/categories/redux/categorySlice";
import schoolReducer from "../School-Quiz-Mgt-admin/schoolmodule/redux/schoolSlice";
import samplePaperReducer from "../components/Sample Paper/redux/slice";

import boardSlice from "../components/BoardMedium/redux/boardSlice";
import mediumSlice from "../components/BoardMedium/redux/mediumSlice";
import BoardchapterSlice from "../components/BoardMedium/redux/chapterSlice";
import boardQuestionSlice from "../components/BoardMedium/redux/boardQuestionSlice";
const store = configureStore({
  reducer: {
    schoolQuiz: schoolQuizReducer,
    class: classSlice,
    subject: subjectSlice,
    chapter: chapterSlice,
    questionBank: questionBankReducer,
    lawCollegeQuiz: lawCollegeQuizReducer,
    quizManagement: quizMgtReducer,
    schoolQuizManagement: schlQuizMgtReducer,
    category: categoryReducer,
    schools: schoolReducer,
    samplePaper: samplePaperReducer,
    boards: boardSlice,
    mediums: mediumSlice,
    boardChapters: BoardchapterSlice,
    boardQuestion: boardQuestionSlice,
  },
});

export default store;
